module.exports = __webpack_public_path__ + "img/shirt-long-sleeve.6b5b187c.svg";